<template>
  <div class="playout" data-testid="public-layout">
    <slot />
    <Teleport to="body">
      <div id="sheet-portal" />
    </Teleport>
  </div>
</template>

<script setup lang="ts">
/**
 * Frame for sign-in, magic link, invitation and other public pages (05_ПЛАН_ВНЕДРЕНИЯ.md §2.2). It does not depend on
 * the product: a new client arriving by magic link has no product hint yet and must not land in the old 480 px frame.
 * The pages keep their own phone-width column; the frame only gives them the full-height cream background.
 */
</script>

<style scoped lang="scss">
.playout {
  height: var(--app-height, 100dvh);
  width: 100%;
  overflow-y: auto;
  background: var(--cream);
  color: var(--text);

  > :deep(*) {
    max-width: 480px;
    margin-inline: auto;
  }
}
</style>
